<ng-content></ng-content>


// WEBPACK FOOTER //
// ./node_modules/angular2-collapsible/angular2-collapsible.d.ts.CollapsibleHeaderComponent.html